export const mockData = {
  "柴葛解肌汤是一种什么方剂？": {
    answer:
      "柴葛解肌汤是一种传统的中药汤剂，出自《医学传灯》卷下，它主要用于治疗湿热在经，闭塞本身元气，恶寒发热，身首俱痛等症状，它的主要成分包括羌活，干葛，柴胡，川芎，半夏，枳壳，桔梗，厚朴，山楂，黄芩，山栀，甘草等。但是，需要注意的是，由于柴葛解肌汤具有清热解毒的作用，因此不适用于体质虚寒、阳虚体弱的人群。在使用柴葛解肌汤之前，最好咨询医生的建议。",
    graphData: {
      rootId: "a",
      nodes: [
        {
          id: "a",
          text: "柴葛解肌汤",
          type: "方剂",
          color: "#1b9e77",
          borderColor: "#1d7a6e",
        },
        {
          id: "c",
          text: "羌活",
          type: "中药材",
          color: "#2a9d8f",
          borderColor: "#1d7a6e",
        },
        {
          id: "e",
          text: "干葛",
          type: "中药材",
          color: "#2a9d8f",
          borderColor: "#1d7a6e",
        },
        {
          id: "d",
          text: "柴胡",
          type: "中药材",
          color: "#2a9d8f",
          borderColor: "#1d7a6e",
        },
        {
          id: "f",
          text: "川芎",
          type: "中药材",
          color: "#2a9d8f",
          borderColor: "#1d7a6e",
        },
        {
          id: "g",
          text: "半夏",
          type: "中药材",
          color: "#2a9d8f",
          borderColor: "#1d7a6e",
        },
        {
          id: "h",
          text: "枳壳",
          type: "中药材",
          color: "#2a9d8f",
          borderColor: "#1d7a6e",
        },
        {
          id: "i",
          text: "桔梗",
          type: "中药材",
          color: "#2a9d8f",
          borderColor: "#1d7a6e",
        },
        {
          id: "j",
          text: "厚朴",
          type: "中药材",
          color: "#2a9d8f",
          borderColor: "#1d7a6e",
        },
        {
          id: "k",
          text: "山楂",
          type: "中药材",
          color: "#2a9d8f",
          borderColor: "#1d7a6e",
        },
        {
          id: "l",
          text: "黄芩",
          type: "中药材",
          color: "#2a9d8f",
          borderColor: "#1d7a6e",
        },
        {
          id: "m",
          text: "山栀",
          type: "中药材",
          color: "#2a9d8f",
          borderColor: "#1d7a6e",
        },
        {
          id: "n",
          text: "甘草",
          type: "中药材",
          color: "#2a9d8f",
          borderColor: "#1d7a6e",
        },
        {
          id: "o",
          text: "伤于酒",
          type: "病症",
          color: "#e76f51",
          borderColor: "#d1653e",
        },
        {
          id: "p",
          text: "湿热在经",
          type: "病症",
          color: "#e76f51",
          borderColor: "#d1653e",
        },
        {
          id: "q",
          text: "闭塞本身元气",
          type: "病症",
          color: "#e76f51",
          borderColor: "#d1653e",
        },
        {
          id: "r",
          text: "恶寒发热",
          type: "病症",
          color: "#e76f51",
          borderColor: "#d1653e",
        },
        {
          id: "s",
          text: "身首俱痛",
          type: "病症",
          color: "#e76f51",
          borderColor: "#d1653e",
        },
      ],
      lines: [
        { from: "a", to: "c", text: "处方" },
        { from: "a", to: "e", text: "处方" },
        { from: "a", to: "d", text: "处方" },
        { from: "a", to: "f", text: "处方" },
        { from: "a", to: "g", text: "处方" },
        { from: "a", to: "h", text: "处方" },
        { from: "a", to: "i", text: "处方" },
        { from: "a", to: "j", text: "处方" },
        { from: "a", to: "k", text: "处方" },
        { from: "a", to: "l", text: "处方" },
        { from: "a", to: "m", text: "处方" },
        { from: "a", to: "n", text: "处方" },
        { from: "a", to: "o", text: "主治" },
        { from: "a", to: "p", text: "主治" },
        { from: "a", to: "q", text: "主治" },
        { from: "a", to: "r", text: "主治" },
        { from: "a", to: "s", text: "主治" },
      ],
    },
  },
  "我发烧了，请给我推荐几个方剂。": {
    answer:
      "发烧是身体免疫系统的一种反应，可能是因为感染、炎症、过敏等多种原因引起的。以下是几个针对不同原因引起的发烧的方剂：\n桂枝汤：该方剂能够发汗解表，适用于感冒、流感引起的发热、恶寒、头痛等症状。它出自于《医略六书》卷二十五，主要处方包括白术三钱（炒），桂枝一钱半，白芍一钱半，炙草八分，大枣3枚，生姜3片等，用法是水煎，去滓温服。\n五苓散：该方剂能够利水消肿，适用于因湿邪引起的发热、头痛、口渴等症状。它出自于《医方类聚》，主要成分包括泽泻，滑石，赤茯苓，白术，猪苓等。\n以上方剂建议在中医师的指导下使用，不宜自行使用，尤其对于孕妇、儿童、老人等特殊人群，应当谨慎使用。同时，若发热严重，伴有呼吸急促、胸痛等症状，应当及时就医。",
    graphData: {
      rootId: "a",
      nodes: [
        {
          id: "a",
          text: "桂枝汤",
          type: "方剂",
          color: "#1b9e77",
          borderColor: "#1d7a6e",
        },
        {
          id: "c",
          text: "白术三钱（炒）",
          color: "#2a9d8f",
          type: "中药材",
          borderColor: "#1d7a6e",
        },
        {
          id: "d",
          text: "桂枝一钱",
          type: "中药材",
          color: "#2a9d8f",
          borderColor: "#1d7a6e",
        },
        {
          id: "dd2",
          text: "白芍一钱半",
          type: "中药材",
          color: "#2a9d8f",
          borderColor: "#1d7a6e",
        },
        {
          id: "d3",
          text: "炙草八分",
          type: "中药材",
          color: "#2a9d8f",
          borderColor: "#1d7a6e",
        },
        {
          id: "d4",
          text: "大枣3枚",
          type: "中药材",
          color: "#2a9d8f",
          borderColor: "#1d7a6e",
        },
        {
          id: "d5",
          text: "生姜3片",
          type: "中药材",
          color: "#2a9d8f",
          borderColor: "#1d7a6e",
        },
        {
          id: "e",
          text: "发热",
          type: "病症",
          color: "#e76f51",
          borderColor: "#d1653e",
        },
        {
          id: "f",
          text: "恶寒",
          type: "病症",
          color: "#e76f51",
          borderColor: "#d1653e",
        },
        {
          id: "g",
          text: "头痛",
          type: "病症",
          color: "#e76f51",
          borderColor: "#d1653e",
        },
        {
          id: "h",
          text: "感冒",
          type: "病症",
          color: "#e76f51",
          borderColor: "#d1653e",
        },
        {
          id: "i",
          text: "流感",
          type: "病症",
          color: "#e76f51",
          borderColor: "#d1653e",
        },
        {
          id: "fangji",
          text: "五苓散",
          type: "方剂",
          color: "#1b9e77",
          borderColor: "#1d7a6e",
        },
        {
          id: "c1",
          text: "泽泻",
          type: "中药材",
          color: "#2a9d8f",
          borderColor: "#1d7a6e",
        },
        {
          id: "c2",
          text: "滑石",
          type: "中药材",
          color: "#2a9d8f",
          borderColor: "#1d7a6e",
        },
        {
          id: "c3",
          text: "赤茯苓",
          type: "中药材",
          color: "#2a9d8f",
          borderColor: "#1d7a6e",
        },
        {
          id: "c4",
          text: "白术",
          type: "中药材",
          color: "#2a9d8f",
          borderColor: "#1d7a6e",
        },
        {
          id: "c5",
          text: "猪苓",
          type: "中药材",
          color: "#2a9d8f",
          borderColor: "#1d7a6e",
        },
        {
          id: "d1",
          text: "湿邪",
          type: "病症",
          color: "#e76f51",
          borderColor: "#d1653e",
        },
        {
          id: "d2",
          text: "口渴",
          type: "病症",
          color: "#e76f51",
          borderColor: "#d1653e",
        },
      ],
      lines: [
        { from: "a", to: "c", text: "处方" },
        { from: "a", to: "d", text: "处方" },
        { from: "a", to: "dd2", text: "处方" },
        { from: "a", to: "d3", text: "处方" },
        { from: "a", to: "d4", text: "处方" },
        { from: "a", to: "d5", text: "处方" },
        { from: "a", to: "e", text: "主治" },
        { from: "a", to: "f", text: "主治" },
        { from: "a", to: "g", text: "主治" },
        { from: "h", to: "e", text: "引起" },
        { from: "h", to: "g", text: "引起" },
        { from: "i", to: "e", text: "引起" },
        { from: "i", to: "g", text: "引起" },
        { from: "a", to: "c1", text: "处方" },
        { from: "a", to: "c2", text: "处方" },
        { from: "a", to: "c3", text: "处方" },
        { from: "a", to: "c4", text: "处方" },
        { from: "a", to: "c5", text: "处方" },
        { from: "fangji", to: "e", text: "主治" },
        { from: "fangji", to: "g", text: "主治" },
        { from: "fangji", to: "d2", text: "主治" },
        { from: "d1", to: "e", text: "引起" },
        { from: "d1", to: "g", text: "引起" },
        { from: "d2", to: "g", text: "引起" },
      ],
    },
  },
  "有哪些方剂包含了人参，请列举几个。": {
    answer:
      "很多方剂都包含人参，以下是一些常见的方剂：\n\n1. 人参汤：由人参、甘草、黄芪等药材组成，是《金匮要略》中常用的方剂，具有补益气血、益气固表等功效。\n\n2. 再造丸：由人参、黄芪、白术、茯苓等药材组成，具有益气健脾、补益气血等功效。\n\n3. 当归四逆汤：由人参、当归、白芍、甘草等药材组成，具有温阳补血、调和营卫等功效。\n\n4. 保元汤：由人参、黄芪、肉桂、甘草等药材组成，具有益气固表、温阳补血等功效。\n\n5. 百合固金汤：由人参、黄芪、山药、熟地黄等药材组成，具有益气固表、补益精血等功效。\n\n需要注意的是，人参虽然是一种常用的中药材，但不同的方剂中人参的用量、搭配和其他药材的组合方式都会有所不同，因此在使用时需要根据具体病情和治疗方案进行调整。",
    graphData: {
      rootId: "a",
      nodes: [
        {
          id: "人参",
          text: "人参",
          type: "中药材",
        },
        {
          id: "人参汤",
          text: "人参汤",
          type: "方剂",
        },
        {
          id: "甘草",
          text: "甘草",
          type: "中药材",
        },
        {
          id: "黄芪",
          text: "黄芪",
          type: "中药材",
        },
        {
          id: "再造丸",
          text: "再造丸",
          type: "方剂",
        },
        {
          id: "白术",
          text: "白术",
          type: "中药材",
        },
        {
          id: "茯苓",
          text: "茯苓",
          type: "中药材",
        },
        {
          id: "当归四逆汤",
          text: "当归四逆汤",
          type: "方剂",
        },
        {
          id: "当归",
          text: "当归",
          type: "中药材",
        },
        {
          id: "白芍",
          text: "白芍",
          type: "中药材",
        },
        {
          id: "肉桂",
          text: "肉桂",
          type: "中药材",
        },
        {
          id: "山药",
          text: "山药",
          type: "中药材",
        },
        {
          id: "熟地黄",
          text: "熟地黄",
          type: "中药材",
        },
        {
          id: "保元汤",
          text: "保元汤",
          type: "方剂",
        },
        {
          id: "百合固金汤",
          text: "百合固金汤",
          type: "方剂",
        },
        {
          id: "补益气血",
          text: "补益气血",
          type: "中药材功效",
        },
        {
          id: "益气固表",
          text: "益气固表",
          type: "中药材功效",
        },
        {
          id: "益气健脾",
          text: "益气健脾",
          type: "中药材功效",
        },
        {
          id: "温阳补血",
          text: "温阳补血",
          type: "中药材功效",
        },
        {
          id: "调和营卫",
          text: "调和营卫",
          type: "中药材功效",
        },
      ],
      lines: [
        { from: "人参", to: "人参汤", text: "组成成分" },
        { from: "甘草", to: "人参汤", text: "组成成分" },
        { from: "黄芪", to: "人参汤", text: "组成成分" },
        { from: "人参", to: "再造丸", text: "组成成分" },
        { from: "黄芪", to: "再造丸", text: "组成成分" },
        { from: "白术", to: "再造丸", text: "组成成分" },
        { from: "茯苓", to: "再造丸", text: "组成成分" },
        { from: "人参", to: "当归四逆汤", text: "组成成分" },
        { from: "当归", to: "当归四逆汤", text: "组成成分" },
        { from: "白芍", to: "当归四逆汤", text: "组成成分" },
        { from: "甘草", to: "当归四逆汤", text: "组成成分" },
        { from: "人参", to: "保元汤", text: "组成成分" },
        { from: "黄芪", to: "保元汤", text: "组成成分" },
        { from: "肉桂", to: "保元汤", text: "组成成分" },
        { from: "甘草", to: "保元汤", text: "组成成分" },
        { from: "人参", to: "百合固金汤", text: "组成成分" },
        { from: "黄芪", to: "百合固金汤", text: "组成成分" },
        { from: "山药", to: "百合固金汤", text: "组成成分" },
        { from: "熟地黄", to: "百合固金汤", text: "组成成分" },
        { from: "人参汤", to: "补益气血", text: "包含功效" },
        { from: "人参汤", to: "益气固表", text: "包含功效" },
        { from: "再造丸", to: "益气健脾", text: "包含功效" },
        { from: "再造丸", to: "补益气血", text: "包含功效" },
        { from: "当归四逆汤", to: "温阳补血", text: "包含功效" },
        { from: "当归四逆汤", to: "调和营卫", text: "包含功效" },
      ],
    },
  },
};
